export default "__VITE_ASSET___ONahPoy__"